<template>
  <div id="container"></div>
</template>
<script>
// import { shallowRef } from '@vue/reactivity'
import AMapLoader from "@amap/amap-jsapi-loader";

export default {
  name: "MapModular",
  data() {
    return {};
  },
  methods: {
    initMap() {
      AMapLoader.load({
        key: "240e8d6dace5f9a68476252ad0198ec8", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [""], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          this.map = new AMap.Map("container", {
            //设置地图容器id
            viewMode: "3D", //是否为3D地图模式
            zoom: 13, //初始化地图级别
            center: [117.02, 36.16], //初始化地图中心点位置
          });
          let marker = new AMap.Marker({
            position: new AMap.LngLat(117.02, 36.16), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: "泰安普惠电气科技有限公司",
          });
          this.map.add(marker);

          // 移除已创建的 marker
          // this.map.remove(marker);
          // this.map.setFitView();
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  mounted() {
    //DOM初始化完成进行地图初始化
    this.initMap();
  },
};
</script>
<style  scoped>
#container {
  padding: 0px;
  margin: 0px;
  width: 100%;
  height: 100%;
}
</style>
</style>


// WEBPACK FOOTER //
// src/components/public/map.vue